/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_WatchesInputs */

const en_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watches`)
};

const es_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relojes`)
};

const fr_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montres`)
};

const de_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhren`)
};

const ja_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時計`)
};

const zh_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`腕表`)
};

const ar_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساعات`)
};

const id_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jam Tangan`)
};

const it_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orologi`)
};

const ru_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часы`)
};

const pt_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relógios`)
};

const ko_listing_category_watches = /** @type {(inputs: Listing_Category_WatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시계`)
};

/**
* | output |
* | --- |
* | "Watches" |
*
* @param {Listing_Category_WatchesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_watches = /** @type {((inputs?: Listing_Category_WatchesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_WatchesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_watches(inputs)
	if (locale === "es") return es_listing_category_watches(inputs)
	if (locale === "fr") return fr_listing_category_watches(inputs)
	if (locale === "de") return de_listing_category_watches(inputs)
	if (locale === "ja") return ja_listing_category_watches(inputs)
	if (locale === "zh") return zh_listing_category_watches(inputs)
	if (locale === "ar") return ar_listing_category_watches(inputs)
	if (locale === "id") return id_listing_category_watches(inputs)
	if (locale === "it") return it_listing_category_watches(inputs)
	if (locale === "ru") return ru_listing_category_watches(inputs)
	if (locale === "pt") return pt_listing_category_watches(inputs)
	return ko_listing_category_watches(inputs)
});